import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  RootRef,
  Paper,
  Grid,
  Button,
  Typography,
  Input,
  InputAdornment,
  Divider,
  FormGroup,
  FormControlLabel,
} from "@material-ui/core";

import Loading from "../../loading";
import { styles } from "./styles";

class MediaUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arrayMedia: [],
    };
    this.handleSelectImage = this.handleSelectImage.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
  }
  componentDidMount() {
    this.props.onRef(this);
    if (this.props.media) {
      let arrayMedia = this.props.media.map(item => {
        if (item.mediaType.match("video")) item.mediaURL = this.getThumbnailVideo(item.mediaURL, item.mediaType)
        return {
          data: item.mediaURL,
          time: item.mediaLength,
          name: item.mediaName
        }
      })
      this.setState({ arrayMedia: arrayMedia })
    }
  }
  // a little function to help us with reordering the result
  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  getItemStyle = (isDragging, draggableStyle) => ({
    // styles we need to apply on draggables
    ...draggableStyle,
    ...(isDragging && {
      background: "rgb(235,235,235)",
    }),
  });
  getListMedia = () => {
    return this.state.arrayMedia
  }
  handleAddMedia = (index) => {
    let { arrayMedia } = this.state;
    arrayMedia.splice(index + 1, 0, {
      file: {},
      time: 3,
      data: "",
    });
    this.setState({ arrayMedia });
  };
  handleRemoveMedia = (index) => {
    let { arrayMedia } = this.state;
    arrayMedia.splice(index, 1);
    this.setState({ arrayMedia });
  };
  handleSelectImage(e, index) {
    let { arrayMedia } = this.state;
    let file = e.target.files[0];
    let reader = new FileReader();
    let _this = this;
    this.loading.startLoading();
    if (window.FileReader) {
      if (file.type.match("image")) {
        reader.onload = function (r) {
          arrayMedia[index] = {
            file: file,
            data: r.target.result,
            time: 3
          };
          _this.setState({ arrayMedia });
        };
        reader.readAsDataURL(file);
      } else {
        reader.onload = function (r) {
          let blob = new Blob([r.target.result], { type: file.type });
          let url = URL.createObjectURL(blob);
          let video = document.createElement("video");
          let timeupdate = function () {
            if (snapImage()) {
              video.removeEventListener("timeupdate", timeupdate);
              video.pause();
            }
          };
          video.addEventListener("loadeddata", function () {
            if (snapImage()) {
              video.removeEventListener("timeupdate", timeupdate);
            }
          });
          var snapImage = function () {
            var canvas = document.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            canvas
              .getContext("2d")
              .drawImage(video, 0, 0, canvas.width, canvas.height);
            var image = canvas.toDataURL();
            var success = image.length > 100000;
            if (success) {
              arrayMedia[index] = {
                file: file,
                data: image,
                time: Math.round(video.duration)
              };
              _this.setState({ arrayMedia });
              URL.revokeObjectURL(url);
            }
            return success;
          };
          video.addEventListener("timeupdate", timeupdate);
          video.preload = "metadata";
          video.src = url;
          // Load video in Safari / IE11
          video.muted = true;
          video.playsInline = true;
          video.play();
        };
        reader.readAsArrayBuffer(file);
      }
    } else {
      this.mSnackbar.handleClick(
        "Sorry, your browser does'nt support for preview",
        "warning"
      );
    }
    this.loading.stopLoading();
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const arrayMedia = this.reorder(
      this.state.arrayMedia,
      result.source.index,
      result.destination.index
    );
    this.setState({
      arrayMedia,
    });
  }

  handleChange = (event, index) => {
    let { arrayMedia } = this.state;
    let name = event.target.name;
    let value = event.target.value;
    arrayMedia[index][name] = value;
    this.setState({ arrayMedia });
  };
  render() {
    const { t, history, classes, data } = this.props;
    const { arrayMedia } = this.state;
    return (
      <React.Fragment>
        <Loading onRef={(id) => (this.loading = id)} />
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <RootRef
                rootRef={provided.innerRef}
                {...provided.droppableProps}
              >
                <div>
                  {arrayMedia.map((item, index) => {
                    return (
                      <Draggable
                        key={index}
                        draggableId={`item-${index}`}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <Paper
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={this.getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                            className={classes.root}
                          >
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={2}>
                                <Typography
                                  variant="body1"
                                  className={classes.title}
                                >
                                  {t("digital_signal_create_upload")}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                container
                                xs={12}
                                sm={10}
                                justify="flex-end"
                              >
                                <Button
                                  variant={"contained"}
                                  color={"primary"}
                                  className={classes.button}
                                  onClick={() => this.handleAddMedia(index)}
                                >
                                  {t("digital_signal_create_add_media")}
                                </Button>
                                <Button
                                  variant={"contained"}
                                  color={"secondary"}
                                  className={classes.button}
                                  onClick={() => this.handleRemoveMedia(index)}
                                >
                                  {t("digital_signal_create_remove_media")}
                                </Button>
                              </Grid>
                            </Grid>
                            <Divider className={classes.breakLine} />
                            <Grid container spacing={3}>
                              <Grid
                                item
                                container
                                xs={12}
                                sm={12}
                                justify="center"
                                alignItems="center"
                                className={classes.containerContent}
                              >
                                {!item.data && (
                                  <div
                                    className={classNames(
                                      classes.displayFlex,
                                      classes.wrapContent,
                                      classes.hoverContent
                                    )}
                                    onClick={() =>
                                      document
                                        .getElementById(`add-media-${index}`)
                                        .click()
                                    }
                                  >
                                    <div className={classes.flex1}>
                                      <img
                                        src="/images/add_file.svg"
                                        className={classes.iconUpload}
                                      />
                                    </div>
                                    <div
                                      className={classNames(
                                        classes.flex1,
                                        classes.marginText
                                      )}
                                    >
                                      <Typography
                                        variant="h3"
                                        classes={{ h3: classes.h3 }}
                                      >
                                        Select Files
                                  </Typography>
                                      <Typography
                                        variant="body1"
                                        classes={{ body1: classes.body1 }}
                                      >
                                        Drop files here or browse click thorough
                                        your machine
                                  </Typography>
                                    </div>
                                  </div>
                                )}
                                {item.data && (
                                  <div
                                    className={classNames(
                                      classes.displayFlex,
                                      classes.wrapContent
                                    )}
                                  >
                                    <div
                                      className={classNames(
                                        classes.flex1,
                                        classes.hoverContent
                                      )}
                                    >
                                      <div
                                        onClick={() =>
                                          document
                                            .getElementById(`add-media-${index}`)
                                            .click()
                                        }
                                      >
                                        <img
                                          className={classes.imageUpload}
                                          src={item.data}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className={classNames(
                                        classes.flex1,
                                        classes.marginText
                                      )}
                                    >
                                      <Typography
                                        variant="body1"
                                        classes={{ body1: classes.body1 }}
                                      >
                                        {item.file ? item.file.name : item.name}
                                      </Typography>
                                      <FormGroup
                                        classes={{ root: classes.formGroupRoot }}
                                      >
                                        <FormControlLabel
                                          control={
                                            <Input
                                              placeholder={"3"}
                                              name="time"
                                              value={item.time}
                                              inputProps={{
                                                "aria-label": "description",
                                              }}
                                              onChange={(e) =>
                                                this.handleChange(e, index)
                                              }
                                              endAdornment={
                                                <InputAdornment position="end">
                                                  s
                                            </InputAdornment>
                                              }
                                            />
                                          }
                                          label="Time"
                                          labelPlacement="start"
                                          classes={{ label: classes.rootLabel }}
                                        />
                                      </FormGroup>
                                    </div>
                                  </div>
                                )}
                                <Input
                                  className={classes.inputImage}
                                  disableUnderline
                                  id={`add-media-${index}`}
                                  type="file"
                                  margin="none"
                                  onChange={(e) => this.handleSelectImage(e, index)}
                                />
                              </Grid>
                            </Grid>
                          </Paper>
                        )}
                      </Draggable>
                    )
                  })}
                  {provided.placeholder}
                </div>
              </RootRef>
            )}
          </Droppable>
        </DragDropContext>
      </React.Fragment>
    );
  }
}
MediaUpload.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
});
const mapDispatch = (dispatch) => ({
  create: dispatch.digitalSignal.create,
  saveStorage: dispatch.upload.saveStorage,
});
export default translate("translations")(
  withStyles(styles, { withTheme: true })(
    connect(mapState, mapDispatch)(MediaUpload)
  )
);
